import React from "react";
import { Offer } from "../utils/API";

const CouponCode: React.FC<{ couponCodeData: Offer[] }> = ({
  couponCodeData,
}) => {
  const getBrandName = (item: Offer) => {
    if (item.merchant_name) return item.merchant_name;
    if (!item.store) return "";
    return item.store.replace(/\.com$/, "");
  };

  const clamp = (s: string, n: number) =>
    s.length > n ? `${s.slice(0, n)}…` : s;

  const getLandingPageUrl = (item: Offer) =>
    item.affiliate_link || item.url || item.deeplink || "";

  return (
    <>
      <ul className="flex flex-col gap-6 md:gap-10 h-auto w-full min-w-0 flex-1">
        {couponCodeData.map((item) => {
          const landingPageUrl = getLandingPageUrl(item);

          return (
            <li
              key={item.offer_id}
              className="relative w-full min-w-0 px-3.5 md:px-0"
            >
              <div className="w-full min-w-0 rounded-[10px] shadow-inset-bottom hover:shadow-lg transition-all duration-300 overflow-hidden">
                <div className="bg-white rounded-[10px] md:pr-[30px] overflow-hidden min-w-0">
                  <div className="flex w-full min-w-0">
                    <div className="border-r-2 border-[#0000001a] border-dashed flex flex-shrink-0 items-center justify-center flex-col w-[92px] p-1 md:p-2 md:w-[180px]">
                      <div className="w-full min-w-0 text-base md:text-[28px] font-source font-black text-[#ef312b] py-1 text-center line-clamp-2 break-words">
                        {window.innerWidth > 768
                          ? item.label
                          : clamp(item.label, 10)}
                      </div>
                    </div>
                    <div className="flex-1 flex items-center justify-between min-w-0 pl-4 py-3.5 md:pl-6 md:py-5">
                      <div className="flex-1 min-w-0 overflow-hidden mr-10 md:mr-12 md:flex md:flex-col md:gap-2">
                        <div className="w-full min-w-0 overflow-hidden break-words font-bold text-lg md:text-2xl leading-6 md:leading-[30px] line-clamp-1 capitalize">
                          {getBrandName(item)}
                        </div>
                        <div className="w-full min-w-0 overflow-hidden break-words font-medium text-sm leading-6 md:font-semibold md:text-lg md:leading-6 md:text-[#40404a99] line-clamp-1 capitalize">
                          {item.title}
                        </div>
                      </div>
                      <a
                        href={landingPageUrl || undefined}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`md:hidden absolute right-3.5 w-[24px] h-[48px] flex items-center justify-center bg-[#ffbc0f] rounded-l-full ${
                          landingPageUrl ? "" : "pointer-events-none opacity-50"
                        }`}
                      >
                        <img
                          src="/icons/red-right-arrow.svg"
                          alt="code-right-arrow"
                          loading="lazy"
                          decoding="async"
                          width="7"
                          height="13"
                          className="w-[8px] h-[14px] ml-1.5"
                        />
                      </a>
                      <div className="hidden md:block relative">
                        <a
                          href={landingPageUrl || undefined}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`block ${
                            landingPageUrl
                              ? "cursor-pointer"
                              : "pointer-events-none opacity-50"
                          }`}
                        >
                          <div className="w-[120px] hover:w-[100px] hover:scale-105 shadow-inset-right hover:shadow-neon bg-[#ffbc0f] font-black text-2xl text-[#130300] leading-7 rounded-md h-12 flex justify-center items-center transition-all duration-300 overflow-hidden before:content-[''] before:absolute before:w-12 before:h-full before:bg-gradient-to-t before:from-white/0 before:via-white/30 before:to-white/0 before:translate-x-[-200%] before:skew-x-[-45deg] before:transition-transform hover:before:translate-x-[200%] before:duration-700 after:content-[''] after:absolute after:inset-0 after:bg-gradient-to-r after:from-background-500 after:via-background-700 after:to-background-500 after:opacity-0 hover:after:opacity-30 after:transition-opacity after:duration-300">
                            GET
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default CouponCode;
